import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { getBaseUrl } from '../utils/api';

const getApiUrl = getBaseUrl;

export const AdminProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking
  const [adminUser, setAdminUser] = useState(null);

  useEffect(() => {
    // Skip if returning from OAuth callback
    if (window.location.hash?.includes('session_id=')) {
      return;
    }

    const checkAuth = async () => {
      try {
        const apiUrl = getApiUrl();
        const response = await axios.get(`${apiUrl}/api/admin/auth/me`, {
          withCredentials: true
        });
        
        if (response.data && response.data.admin_id) {
          setAdminUser(response.data);
          setIsAuthenticated(true);
          localStorage.setItem('admin_user', JSON.stringify(response.data));
        } else {
          throw new Error('Invalid response');
        }
      } catch (error) {
        console.log('Admin not authenticated');
        setIsAuthenticated(false);
        localStorage.removeItem('admin_user');
        localStorage.removeItem('admin_token');
      }
    };

    checkAuth();
  }, [location.pathname]);

  // Still checking
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center">
        <Loader2 size={40} className="text-[var(--sur-couleur)] animate-spin" />
      </div>
    );
  }

  // Not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminProtectedRoute;
